import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IPropertyFaqAnswerResponse, PropertyFaqQuestionKey} from "../types/IPropertyFaq";
import {extractPropertyFaqAnswer} from "../utils/extract_property_faq_answer";

interface IPostPropertyFaqAnswerPayload {
    propertyId: number;
    question: PropertyFaqQuestionKey;
}

export const transformPropertyFaqAnswerError = (response: FetchBaseQueryError) => getIgnoredNotifyResponse(response, [response.status]);

export const postPropertyFaqAnswerApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postPropertyFaqAnswer: build.mutation<IPropertyFaqAnswerResponse, IPostPropertyFaqAnswerPayload>({
            queryFn: async ({propertyId, question}, _api, _extraOptions, baseQuery) => {
                const result = await baseQuery({
                    url: apiV2Link.property.faq(),
                    method: "POST",
                    body: {
                        question,
                        property_id: propertyId
                    },
                    responseHandler: "text"
                });

                if (result.error) {
                    return {error: transformPropertyFaqAnswerError(result.error)};
                }

                const answer = extractPropertyFaqAnswer(result.data);

                if (!answer) {
                    // Treat empty/unparseable 2xx as a silent RTK error so the FAQ item shows inline retry UI
                    // instead of an empty answer. getIgnoredNotifyResponse suppresses global error toasts.
                    return {
                        error: transformPropertyFaqAnswerError({
                            status: "PARSING_ERROR",
                            originalStatus: result.meta?.response?.status ?? 200,
                            data: String(result.data ?? ""),
                            error: "FAQ API returned an invalid answer"
                        })
                    };
                }

                return {data: {answer}};
            }
        })
    })
});

export const {usePostPropertyFaqAnswerMutation} = postPropertyFaqAnswerApi;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {IPropertyFaqAnswerResponse, PropertyFaqQuestionKey} from "../types/IPropertyFaq";
import {extractPropertyFaqAnswer} from "../utils/extract_property_faq_answer";

interface IPostPropertyFaqAnswerPayload {
    propertyId: number;
    question: PropertyFaqQuestionKey;
}

export const transformPropertyFaqAnswerError = (response: FetchBaseQueryError) => getIgnoredNotifyResponse(response, [response.status]);

export const postPropertyFaqAnswerApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postPropertyFaqAnswer: build.mutation<IPropertyFaqAnswerResponse, IPostPropertyFaqAnswerPayload>({
            queryFn: async ({propertyId, question}, _api, _extraOptions, baseQuery) => {
                const result = await baseQuery({
                    url: apiV2Link.property.faq(),
                    method: "POST",
                    body: {
                        question,
                        property_id: propertyId
                    },
                    responseHandler: "text"
                });

                if (result.error) {
                    return {error: transformPropertyFaqAnswerError(result.error)};
                }

                const answer = extractPropertyFaqAnswer(result.data);

                if (!answer) {
                    // Treat empty/unparseable 2xx as a silent RTK error so the FAQ item shows inline retry UI
                    // instead of an empty answer. getIgnoredNotifyResponse suppresses global error toasts.
                    return {
                        error: transformPropertyFaqAnswerError({
                            status: "PARSING_ERROR",
                            originalStatus: result.meta?.response?.status ?? 200,
                            data: String(result.data ?? ""),
                            error: "FAQ API returned an invalid answer"
                        })
                    };
                }

                return {data: {answer}};
            }
        })
    })
});

export const {usePostPropertyFaqAnswerMutation} = postPropertyFaqAnswerApi;
